import PanResponder from "../vendor/react-native/PanResponder/index";
var PanResponder_default = PanResponder;
export {
  PanResponder_default as default
};
//# sourceMappingURL=index.js.map
